var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebApiDb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1877_8080)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.9032 18.2325L4.09375 18.2035L4.09722 12.4106L50.9069 12.4396L50.9032 18.2325Z",
    fill: "#2D3232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7996 27.5346L38.7051 23.4376L46.8079 15.3348L39.0129 7.53361L43.1089 3.43835L54.9996 15.3363L42.7996 27.5346Z",
    fill: "#2D3232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9032 39.9679L4.09375 39.939L4.09722 34.1461L50.9069 34.1751L50.9032 39.9679Z",
    fill: "#2D3232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8907 48.9402L0 37.0423L12.1997 24.844L16.2943 28.941L8.19028 37.0437L15.9867 44.8453L11.8907 48.9402Z",
    fill: "#2D3232"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1877_8080"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebApiDb);
export default __webpack_public_path__ + "static/media/webApiDb.df98e97d91db8cb59d47de8c828e201e.svg";
export { ForwardRef as ReactComponent };